module.exports = __webpack_public_path__ + "img/browser.00f640dd.svg";